app.controller("ApartmentNostoController",
	["$scope", "ApartmentSearchModel", "ApartmentSearchService", "$location", "$filter", function($scope, ApartmentSearchModel, ApartmentSearchService, $location, $filter) {

		// Scope vars
		$scope.nostoProducts = [];
		$scope.nostoProductsSort = {};
		$scope.searchID = undefined;
		$scope.query = ApartmentSearchService.CreateQuery();
		$scope.searchResults = ApartmentSearchModel.results;
		$scope.Utils = window.Utils;

		$scope.ParseOpenHouseDate = function(secs) {
			var date = $filter('date')(secs * 1000, 'EEEE dd.MM klo HH:mm');
			return date.replace(/^\w/, function (chr) {
				return chr.toUpperCase();
			});
		};

		/**
		 * Search nosto properties
		 *
		 * @param searchID
		 */
		$scope.searchNosto = function(searchID) {

			$scope.searchID = searchID;

			// If we call this, before nosto has been initalized or we don't have products, don't call api!
			if (!$scope.nostoProducts || $scope.nostoProducts.length === 0) {
				console.log('No search. No nostoProducts!');
				return;
			}

			// Add nostoProducts to constraints
			for(var i = 0; i < $scope.nostoProducts.length; i++) {
				$scope.query.AddPropertyConstraint($scope.nostoProducts[i]);
			}

			// Allow nosto even if redirectSearch
			var redirectSearch = ApartmentSearchService.redirectSearch;
			ApartmentSearchService.redirectSearch = false;
			ApartmentSearchService.RunQuery($scope.query, $scope.searchID, false, $scope.processNosto);
			ApartmentSearchService.redirectSearch = redirectSearch;
		};

		/**
		 * Nosto properties have been fetched, sort and show them.
		 */
		$scope.processNosto = function() {
			// Found results? Hide all classes matchin .nostoHide
			if ($scope.searchResults[$scope.searchID] && $scope.searchResults[$scope.searchID]['data'] && $scope.searchResults[$scope.searchID]['data']['results'] && $scope.searchResults[$scope.searchID]['data']['results'].length >= 1)
			{
				angular.element(document.getElementsByClassName("nostoHide")).addClass('ng-cloak');
				$scope.searchResults[$scope.searchID]['data']['results'].sort($scope.nostoSort);
			}
		};

		/**
		 * Sort results by Nosto
		 *
		 * @param a
		 * @param b
		 * @returns {number}
		 */
		$scope.nostoSort = function (a,b) {
			if ($scope.nostoProductsSort[a.key] < $scope.nostoProductsSort[b.key]) {
				return -1;
			} else if ($scope.nostoProductsSort[a.key] > $scope.nostoProductsSort[b.key]) {
				return 1;
			} else {
				return 0;
			}
		};

		function nostoHook() {
			if (!window.nostojs) {
				return;
			}
			// Init nostojs, postrender hook
			window.nostojs(function (api) {
				api.listen('postrender', function (data) {
					$scope.nostoProducts = [];
					// Debug properties given as end of the url: ?nosto=1147713,1168653,1168188,1161830&nostodebug=true
					var debugNosto = $location.search().nosto;
					if (typeof debugNosto == "string") {
						debugNosto = debugNosto.split(',');
						for (var d = 0; d < debugNosto.length; d++) {
							$scope.nostoProducts.push(debugNosto[d]);
						}
					}
					// Check properties from Nosto
					if (data.filledElements !== undefined) {
						for (var i in data.filledElements) {
							if (data.filledElements.hasOwnProperty(i)) {
								var nostoElem = document.getElementById(data.filledElements[i]);
								var nostoElemChildren = nostoElem.children;
								for (var c = 0; c < nostoElemChildren.length; c++) {
									var child = nostoElemChildren[c];
									var product = child.getAttribute('data-value');
									if (product) {
										if (product.match(/^[0-9]+$/)) {
											$scope.nostoProducts.push(product);
										}
									}
								}
							}
						}
					}
					// Found products?
					if ($scope.nostoProducts.length >= 1) {
						// Make helper array for sorting
						for (var iii = 0; iii < $scope.nostoProducts.length; iii++) {
							$scope.nostoProductsSort[$scope.nostoProducts[iii].toString()] = iii;
						}
						// Search
						$scope.searchNosto('nosto');
					}
				});
			});
		}

		// No nosto anymore
		/* If nostojs is not loaded, run check with interval and fire nostoHook when nostojs is available */
		/*var testInterval;
		if (!window.nostojs) {
			testInterval = setInterval(function() {
				if (window.nostojs) {
					nostoHook();
					clearInterval(testInterval);
					return;
				}
			}, 500);
		} else {
			nostoHook();
		}*/
	}]
);